import moment from 'moment';
import column from '../../../../common/list-table/helpers/columns';

export default (data, checkboxParameterPopulator, checkedList = [], localChanges, userRole) => {
  const {
    FilteredTextColumn,
    FilteredDateColumn,
    CheckboxColumn,
  } = column(data);

  const identifier = (row) => row.original.rowNumber;
  const isCheckboxDisabled = (row) => (row.original?.validTo ? moment().isAfter(moment(row.original.validTo).add(1, 'day')) : false);
  const isHeaderChecked = checkedList.length === (Array.isArray(data) ? data.filter((item) => !isCheckboxDisabled({ original: item })).length : 0);

  const getTrProps = (state, rowInfo) => {
    if (rowInfo) {
      const isChanged = !!localChanges.find((item) => item.rowNumber === rowInfo.original.rowNumber);
      return {
        style: {
          color: isChanged ? '#EE696D' : null,
        },
      };
    }
    return {};
  };

  return [
    {
      Header: '',
      columns: [
        new CheckboxColumn('', '', '', {
          ...checkboxParameterPopulator(isCheckboxDisabled, checkedList), identifier, isCheckboxDisabled, isHeaderChecked,
        }).withShow(userRole === 'IPC_ADMIN'),
        new FilteredTextColumn('MRD IMPC', 'mrdImpc').withWidth(225).withGetProps(getTrProps),
        new FilteredTextColumn('Denest IMPC', 'denestImpc').withWidth(225).withGetProps(getTrProps),
        new FilteredDateColumn('Valid from', 'validFrom').withWidth(225).withGetProps(getTrProps),
        new FilteredDateColumn('Valid to', 'validTo').withWidth(225).withGetProps(getTrProps),
      ],
    },
  ];
};
